import React from "react";
import { Store } from "public-components/StoreProvider";
let FTCommon, FTUserMessage, FTIsVIP;
if (typeof window !== `undefined`) {
  const common = require("fotor-common");
  FTCommon = common.FTCommon;
  FTUserMessage = common.FTUserMessage;
  FTIsVIP = common.FTIsVIP;
}

const Sign = ({ authModal, signType, callback = () => {} }) => {
  const { dispatch } = React.useContext(Store);
  const [showAuthModal, setShowAuthModal] = React.useState(authModal);
  const checkIsVip = type => {
    FTIsVIP().then(res => {
      dispatch({ type: "UPDATE_IS_VIP", payload: res.status && res.data.isvip });
    });
  };
  const getMessageData = React.useCallback(() => {
    FTUserMessage().then(data => {
      if (data.status) {
        dispatch({ type: "UPDATE_MESSAGE_DATA", payload: data.data });
      } else {
        dispatch({ type: "LOG_OUT" });
      }
    });
  }, [dispatch]);

  const loginFunc = res => {
    if (res.code === 0 || res.code === 2) {
      dispatch({ type: "LOG_IN", payload: res.userInfo.data });
      checkIsVip(1);
      getMessageData();
    }
    if (res.code === 1) {
      dispatch({ type: "LOG_IN", payload: res.userInfo.data });
      getMessageData();
      setShowAuthModal("loginCOM");
    }
    if (res.code !== 1) {
      setShowAuthModal(null);
    }
    if (res.code === 4) {
      callback && callback();
    }
  };

  return (
    <>
      {typeof window !== `undefined` && (
        <FTCommon loginState={loginFunc} modelType={showAuthModal} signType={signType} />
      )}
    </>
  );
};

export default Sign;
